export default __webpack_public_path__ + "static/media/GoldenPalaceMap.fef5214f.jpg";